import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AttributeListLayer from "../components/AttributeListLayer";

const AttributeListPage = () => {
    return (
        <MasterLayout>
            <AttributeListLayer />
        </MasterLayout>
    );
};

export default AttributeListPage;
